import app from 'flarum/forum/app';
import updateDiscussions from './updateDiscussions';
// import updateSearchDiscussions from './updateSearchDiscussions';
import { extend } from 'flarum/common/extend';
import Discussion from 'flarum/common/models/Discussion';
import Model from 'flarum/common/Model';
import DiscussionListState from 'flarum/forum/states/DiscussionListState';

app.initializers.add('dvdfab/discussions', () => {
  // 注册 userList 关系
  Discussion.prototype.userList = Model.hasMany('userList');
  extend(DiscussionListState.prototype, 'requestParams', function (params) {
    if (!params.include) {
      params.include = [];
    }
    if (params.include.indexOf('userList') === -1) {
      params.include.push('userList');
    }
  });
  
  updateDiscussions();
  // updateSearchDiscussions();

});
